export default function LoadingSpinner() {
  return (
    <div className="fixed inset-0 bg-[#11395D] flex items-center justify-center z-50">
      <div className="flex flex-col items-center justify-center">
        <div className="animate-pulse">
          <span className="text-6xl md:text-7xl font-bold text-white">
            <span className="text-[#F4BD21]">Tec</span>
            <span>qnia</span>
          </span>
        </div>
      </div>
    </div>
  );
}
